import type { ApprovalStatus } from './types';

/** Iniciály z jména (max 2 znaky). */
export const initialsOf = (name?: string | null): string => {
  const n = (name || '').trim();
  if (!n) return '—';
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/** Krátký identifikátor (prvních 8 znaků) pro sekundární popisek řádku. */
export const shortId = (id?: string | null): string => (id ? String(id).slice(0, 8) : '—');

/** Vizuální mapování stavu žádosti (barva tečky + varianta badge). */
export const STATUS_VISUAL: Record<
  ApprovalStatus,
  { dot: string; badge: 'warning' | 'default' | 'success' | 'danger' }
> = {
  pending: { dot: 'bg-amber-500', badge: 'warning' },
  draft: { dot: 'bg-neutral-400', badge: 'default' },
  approved: { dot: 'bg-emerald-500', badge: 'success' },
  rejected: { dot: 'bg-red-500', badge: 'danger' },
};

/** Zařadí datum do bucketu Dnes / Včera / Tento týden / Starší. */
export const dateBucket = (value?: string | null): string => {
  if (!value) return 'Starší';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return 'Starší';
  const now = new Date();
  const startOfDay = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const dayMs = 86400000;
  const diffDays = Math.floor((startOfDay(now) - startOfDay(d)) / dayMs);
  if (diffDays <= 0) return 'Dnes';
  if (diffDays === 1) return 'Včera';
  if (diffDays <= 7) return 'Tento týden';
  return 'Starší';
};

/** Relativní čas ("před 2 h", "před 3 d"). */
export const relativeTime = (value?: string | null): string => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const diffMs = Date.now() - d.getTime();
  const min = Math.round(diffMs / 60000);
  if (min < 1) return 'právě teď';
  if (min < 60) return `před ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `před ${h} h`;
  const days = Math.round(h / 24);
  if (days < 30) return `před ${days} d`;
  const months = Math.round(days / 30);
  return `před ${months} měs`;
};

export const formatDate = (value?: string | null): string => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleDateString('cs-CZ');
};

export const formatDateTime = (value?: string | null): string => {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString('cs-CZ');
};
